export default __webpack_public_path__ + "static/img-nhs-optimiser--mobile-98f69ccdf3303ef0fb1b59fd61d23fee.jpg";